import { WebsiteLayout } from '../Layouts/WebsiteLayout';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <WebsiteLayout className="bg-white">
      <section className="pt-[88px] pb-[50px] !px-5 md:px-10">
        <div className="max-w-custom mx-auto">
          <div className="md:flex">
            <div className="md:w-1/2">
              <div className="relative text-center h-full flex flex-col items-center justify-center">
                <span className="text-sm uppercase font-medium font-halyard mb-[1em] block tracking-[1.8px] text-center text-primaryText">
                  About Us
                </span>
                <h2 className="text-[26px] md:text-[40px] lg:text-[58px] leading-[1em] font-halyard font-medium text-primaryText">
                  We Provide Access to Healthcare Services
                </h2>
                <p className="md:text-[17px] font-dm-sans leading-[26px] md:w-3/4 mx-auto mt-[1.7em] text-[#7a7c7f]">
                  We appreciate your trust. Our clients choose us because our
                  platform is secure and reliable.
                </p>
              </div>
            </div>
            <div className="md:w-1/2">
              <div className="relative w-full">
                <iframe
                  width="100%"
                  height="360"
                  src="https://www.youtube.com/embed/DAAtJUUQHHY?si=aDapSz82owcTwnda"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="pb-[60px] md:pb-[120px] !px-5 md:px-10">
        <div className="max-w-custom mx-auto">
          <div className="md:flex">
            <div className="md:w-[42%]">
              <div className="relative">
                <img src="/health/images/secure.jpg" alt="secure" />
              </div>
            </div>
            <div className="md:w-[58%] max-md:pt-[60px]">
              <div className="md:ml-[14%] h-full flex flex-col justify-center">
                <div className="relative">
                  <span className="text-sm uppercase font-halyard font-medium mb-[1em] block tracking-[1.8px] text-primaryText">
                    Total Urgent Health
                  </span>
                  <h2 className="text-[26px] md:text-[40px] lg:text-[58px] leading-[1em] font-halyard font-medium text-primaryText">
                    Make Secure Payments Direct to Healthcare Providers in
                    Zimbabwe.
                  </h2>
                  <p className="md:text-[17px] font-dm-sans leading-[26px] mt-[1.7em] text-[#7a7c7f]">
                    Total Urgent Health is a comprehensive online platform
                    designed to connect healthcare providers with patients
                    across Zimbabwe and facilitate secure, seamless transactions
                    with their family members, including those in the diaspora.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="!px-5 md:px-10">
        <div className="max-w-custom mx-auto">
          <div className="header text-center mb-[70px]">
            <h2 className="text-[23px] md:text-[34px] lg:text-[47px] leading-[1em] font-medium font-halyard !mb-5">
              Our Vision
            </h2>
            <p className="md:text-[17px] font-dm-sans leading-[26px] max-w-[760px] mx-auto text-[#7a7c7f]">
              To transform healthcare access in Zimbabwe by creating an
              integrated, user-friendly platform that seamlessly connects
              patients with healthcare providers, ensuring that quality medical
              care is accessible to everyone, and supported by secure, reliable
              payment options.
            </p>
          </div>
          <div className="md:flex !mb-5 md:mb-[120px]">
            <div className="md:w-[46%]">
              <div className="relative">
                <h2 className="text-[23px] md:text-[34px] lg:text-[47px] leading-[1em] font-medium font-halyard !mb-5">
                  Our Mission
                </h2>
                <p className="text-[17px] font-dm-sans leading-[26px] text-[#7a7c7f]">
                  To enhance the healthcare experience by facilitating secure
                  online payments and connections between patients and
                  healthcare providers. We strive to:
                </p>
                <ul className="text-[17px] font-dm-sans leading-[26px] text-[#7a7c7f] pl-2.5 list-disc space-y-1">
                  <li>
                    Empower patients to access quality healthcare services
                    conveniently.
                  </li>
                  <li>
                    Support healthcare providers in reaching a broader patient
                    base and optimizing their processes.
                  </li>
                  <li>
                    Enable families, especially those in the diaspora, to
                    contribute to their loved ones’ health and wellbeing with
                    ease.
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:w-[54%]">
              <div className="relative md:ml-[14%]">
                <h2 className="text-[23px] md:text-[34px] lg:text-[47px] leading-[1em] font-medium font-halyard !mb-5">
                  Our Values
                </h2>
                <ul className="md:text-[17px] font-dm-sans leading-[26px] text-[#7a7c7f] pl-2.5 list-decimal space-y-1">
                  <li>
                    <b>Accessibility:</b> We believe in making healthcare
                    services available to everyone, regardless of geographic or
                    financial barriers.
                  </li>
                  <li>
                    <b>Security:</b> We prioritize the safety and
                    confidentiality of our users’ information, ensuring that all
                    transactions are secure and reliable.
                  </li>
                  <li>
                    <b>Innovation:</b> We continuously seek to improve and
                    innovate our platform to meet the evolving needs of patients
                    and healthcare providers.
                  </li>
                  <li>
                    <b>Trust:</b> We aim to build and maintain trust with our
                    users through transparency, integrity, and consistent
                    quality service.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="md:flex mb-[60px] md:mb-[120px]">
            <div className="md:w-[46%]">
              <div className="relative">
                <h2 className="text-[23px] md:text-[34px] lg:text-[47px] leading-[1em] font-medium font-halyard !mb-5">
                  Our Goal
                </h2>
                <ul className="md:text-[17px] font-dm-sans leading-[26px] text-[#7a7c7f] pl-2.5 list-disc space-y-1">
                  <li>
                    <b>Expand Accessibility:</b> Ensure high-quality healthcare
                    services are available to all individuals, regardless of
                    location and/or mobility constraints.
                  </li>
                  <li>
                    <b>Enhance Patient Care:</b> Continuously improve our
                    services to provide access to personalized, compassionate,
                    and effective medical care.
                  </li>
                  <li>
                    <b>Leverage Technology:</b> Utilize advanced hi-tech
                    solutions to offer timely and efficient access to healthcare
                    support.
                  </li>
                  <li>
                    <b>Community Engagement:</b> Foster a healthier community
                    through education, support, and proactive access to health
                    management.
                  </li>
                  <li>
                    <b>Sustainable Growth:</b> Build a robust healthcare network
                    that can sustainably meet the growing needs of patients.
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:w-[54%]">
              <div className="relative md:ml-[14%]">
                <h2 className="text-[23px] md:text-[34px] lg:text-[47px] leading-[1em] font-medium font-halyard !mb-5">
                  Partnerships
                </h2>
                <p className="md:text-[17px] font-dm-sans leading-[26px] text-[#7a7c7f] mb-[1.7em]">
                  At Total Urgent Health, we strongly value the impact of
                  collaboration in accessing healthcare services. We actively
                  pursue partnerships with hospitals, clinics, healthcare
                  providers, and community organizations throughout Zimbabwe to
                  broaden our scope and enhance the quality of healthcare
                  provided by all our partners. Through these strategic
                  alliances, our goal is to integrate world-class medical
                  practices and facilitate an uninterrupted, holistic healthcare
                  experience for our patients.
                </p>
                <p className="md:text-[17px] font-dm-sans leading-[26px] text-[#7a7c7f]">
                  We have streamlined our payment process for business accounts
                  to ensure efficiency. Our innovative platform is tailored to
                  connect patients requiring your services promptly and
                  efficiently, enabling you to seamlessly stay in touch with
                  your clientele. With user-friendly mobile and desktop
                  applications, providers can seamlessly transition between
                  devices, enhancing convenience and accessibility for all
                  users.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="max-md:pt-0 py-[120px] !px-5 md:px-10">
        <div className="max-w-custom mx-auto">
          <div className="relative text-center">
            <span className="text-sm uppercase font-halyard font-medium mb-[1em] block tracking-[1.8px] text-center text-primaryText">
              Become a partner
            </span>
            <h2 className="text-[26px] md:text-[40px] lg:text-[58px] leading-[1em] font-halyard font-medium text-primaryText">
              Register as a Service Provider
            </h2>
            <p className="md:text-[17px] font-dm-sans md:w-1/2 mx-auto leading-[26px] my-[2em] text-[#7a7c7f]">
              Join Total Urgent Health today and expand your reach to more
              patients,
              <br className="max-md:hidden" /> streamline your operations, and
              ensure reliable payments.
            </p>
            <Link
              to="/register"
              className="text-sm bg-darkBlue hover:bg-primaryBlue transition font-halyard leading-5 tracking-[1.5px] uppercase text-white px-2 md:px-10 py-[18px] font-medium"
            >
              Register as a Service Provider
            </Link>
          </div>
        </div>
      </section>
    </WebsiteLayout>
  );
};

export default AboutUs;
